export default __webpack_public_path__ + "static/media/slider12.c4d5fe9e.jpeg";